import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classes } from "../utils/classes";
import Ring from "./Ring";
export default function Card(props) {
    const { children, title, className } = props;
    return (_jsxs("div", { className: classes("flex max-h-full w-[32rem] max-w-full scrollbar-thin scrollbar-thumb-alveus-green scrollbar-track-alveus-green-900 flex-col items-center justify-between overflow-y-auto rounded-3xl bg-alveus-green p-5 shadow-sm", !/\b(static|sticky|fixed|absolute)\b/.test(className || "") &&
            "relative", className), children: [title && (_jsx("h2", { className: "mb-2 text-center font-serif text-3xl font-bold text-balance", children: title })), children, _jsx(Ring, { className: "rounded-3xl" })] }));
}
